// extracted by mini-css-extract-plugin
export default {"containerMain":"VideoPage_containerMain__-RZVU","video":"VideoPage_video__Enf1g","containerDados":"VideoPage_containerDados__LnB9S"};